    define(['jquery',
        'core/urls',
        'core/formatting',
        'components/chart',
        'components/analytics-table',
        'components/daterangepicker-v2',
        'core/loading-animation',
        'components/selectize',
        'components/filter-box',
        'components/fake-progress',],
    function($, urls, formatting, chart, analytics_table, drp, loading_animation, selectize_util, filterBox, FakeProgress) {
        
        let interval = 'monthly';     
        
        let filtersProgress = new FakeProgress(
            document.querySelector(".filter-settings .loader-bar")
        );

        let populateMetrics = (data) => {
            let csatCard = document.querySelector(`#cardNetCsatScore`);
            let reviewsCard = document.querySelector(`#cardReviews`);
            let responsesCard = document.querySelector(`#cardResponseRate`);

            if(data && data.length > 0) {
                $('#no-data').collapse('hide'); // hide no-data alert message
                $('#data-area').removeClass('hide'); // return data-area div to normal state

                csatCard.querySelector(".headline-score").innerHTML = formatting.asNetCsatScore(data[0].net_csat_score);
                // csatCard.querySelector(".date-range").innerHTML = `${start.format('DD MMM YYYY')} - ${end.format('DD MMM YYYY')}`

                reviewsCard.querySelector(".headline-score").innerHTML = data[0].total;
                reviewsCard.querySelector(".sentiments").innerHTML = `
                    <div class="sentiment-wrap">
                        <img src="${globals.getSentimentImageUrl(+1)}">
                        <div class="score">${formatting.asPercentage(formatting.cleanPercentageFraction(data[0].positive, data[0].total))}</div>
                    </div>
                    <div class="sentiment-wrap">
                        <img src="${globals.getSentimentImageUrl(0)}">
                        <div class="score">${formatting.asPercentage(formatting.cleanPercentageFraction(data[0].neutral, data[0].total))}</div>
                    </div>
                    <div class="sentiment-wrap">
                        <img src="${globals.getSentimentImageUrl(-1)}">
                        <div class="score">${formatting.asPercentage(formatting.cleanPercentageFraction(data[0].negative, data[0].total))}</div>
                    </div>
                `
                responsesCard.querySelector(".headline-score").innerHTML = `${formatting.asResponseRate(data[0].response_rate)}<div class="symbol">%</div>`;
                responsesCard.querySelector(".details").innerHTML = `
                        <div class="detail-wrap">
                            <div class="title">Surveys Viewed</div>
                            <div class="score">${data[0].total_all}</div>
                        </div>
                        <div class="detail-wrap">
                            <div class="title">Surveys Rated</div>
                            <div class="score">${data[0].total}</div>
                        </div>
                    `;
            } else {
                csatCard.querySelector(".headline-score").innerHTML = "0.0";
                // csatCard.querySelector(".date-range").innerHTML = "last 30 days";

                reviewsCard.querySelector(".headline-score").innerHTML = "0";
                reviewsCard.querySelector(".sentiments").innerHTML = "";

                responsesCard.querySelector(".headline-score").innerHTML = "0.0";
                responsesCard.querySelector(".details").innerHTML = "";                    
            }
        }

        return {
            init: function() {
                filterBox.create(
                    'csat-analytics', // page prefix
                    urls['csat:review-filters'](), // filter data endpoint
                    (data) => {
                        loadData(data)
                    } // callback on filter change
                );

                $('#chart-analytics').on('hoverStartChart', function(event, index) {
                    analytics_table.highlightColumn(index);
                });

                $('#chart-analytics').on('hoverEndChart', function(event, index) {
                    if(index>=0) {
                        analytics_table.clearHighlightColumn(index);
                    }
                });

                var createdChart = chart.create('#chart-analytics');
                var createdTable = analytics_table.create('#analytics');

                function loadData(filterParams) {
                    loading_animation.start();
                    let start = drp.getStartDate();
                    let end = drp.getEndDate();
                    filtersProgress.node.classList.remove("disabled");
                    filtersProgress.startLoading(10);
                    filterParams['start_date'] = start.format("YYYY-MM-DD");
                    filterParams['end_date'] = end.format("YYYY-MM-DD");
                    filterParams['interval'] = interval;
                    $.post(urls['csat:analytics-data'](), JSON.stringify(filterParams)).done( function(data) {
                        $('#analytics tbody tr').empty();
                        $('#analytics thead').empty();

                        populateMetrics(data.keyMetricsData, start, end);
                        
                        createdTable.populate(data.allTheData, interval);
                        createdChart.populate(data.allTheData, interval);
                        loading_animation.complete();
                        filtersProgress.loadFinish();
                        filtersProgress.node.classList.add("disabled");
                    });
                }

                $('table#analytics').on('hoverStartTable', function(event, index) {
                    createdChart.showTooltip(index);
                    analytics_table.highlightColumn(index);
                    $('.table-responsive').stop();
                });

                $('table#analytics').on('hoverEndTable', function(event, index) {
                    createdChart.hideTooltip();
                    if(index>=0) {
                        analytics_table.clearHighlightColumn(index);
                    }
                    $('.table-responsive').stop();
                });

                function refreshComponents() {
                    let filterParams = filterBox.getFilterParams();
                    loadData(filterParams);
                }

                $('.interval-picker .btn').on('click', function(){
                    interval = $(this).find('input[type="radio"]').attr('id');
                    refreshComponents();
                });

                refreshComponents();
            }
        };
    }
);
